import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryNav from './components/CategoryNav';
import LatestArticles from './components/LatestArticles';
import NewsletterSection from './components/NewsletterSection';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <>
      <SEOHead
        title="她之间 - 女女情感连接与故事"
        description="探索女女情感世界，呈现女性与女性之间真实、细腻的情感故事与生活体验。从情感共鸣到日常相处，深度解读女女关系的多元面貌，为有相同经历的你提供温暖的内容空间。"
        keywords="女女,女女情感故事,女女日常生活,女女关系,女性情感共鸣,女女相处之道,女女真实体验"
        canonicalUrl="https://tazhijian.com"
        ogImage="https://readdy.ai/api/search-image?query=Warm%20feminine%20emotional%20connection%20abstract%20art%20with%20soft%20rose%20cream%20tones%2C%20flowing%20organic%20shapes%2C%20love%20between%20women%20themed%2C%20gentle%20minimalist%20design%2C%20warm%20atmosphere&width=1200&height=630&seq=og-home-01&orientation=landscape"
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: '她之间',
          url: 'https://tazhijian.com',
          description: '探索女女情感世界，呈现女性与女性之间真实、细腻的情感故事与生活体验。',
        }}
      />
      <SchemaOrg
        type="WebSite"
        data={{
          name: '她之间',
          url: 'https://tazhijian.com',
          description: '探索女女情感世界，呈现女性与女性之间真实、细腻的情感故事与生活体验。',
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '她之间 - 首页',
          url: 'https://tazhijian.com',
          description: '探索女女情感世界，呈现女性与女性之间真实、细腻的情感故事与生活体验。',
          isPartOf: { '@type': 'WebSite', name: '她之间', url: 'https://tazhijian.com' },
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://tazhijian.com' },
          ],
        }}
      />

      <Navbar />
      <main>
        <Hero />
        <FeaturedArticles />
        <CategoryNav />
        <LatestArticles />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}